<template>
  <!-- Extracted from App.vue: the customer menu UI only -->
  <div class="relative">
    <!-- Error Message -->
    <div v-if="error" class="fixed top-4 left-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg z-50">
      <div class="flex items-center justify-between mb-2">
        <span class="font-medium">خطا در اتصال</span>
        <button @click="error = null" class="text-red-700 hover:text-red-900 text-xl">&times;</button>
      </div>
      <p class="text-sm mb-3">{{ error }}</p>
      <button 
        @click="retryConnection"
        class="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700 transition-colors"
      >
        تلاش مجدد
      </button>
    </div>

    <!-- Header -->
    <header class="sticky top-0 z-40 bg-white/95 backdrop-blur-lg border-b border-brown-100 shadow-sm">
      <div class="container mx-auto px-4 py-2">
        <div class="flex items-center justify-between">
          <!-- Logo Section -->
          <div class="flex items-center space-x-2 md:space-x-4 space-x-reverse">
            <!-- SVG Logo -->
            <div class="relative">
              <img 
                src="@/assets/Logo.png" 
                alt="کبابی مارو" 
                class="navbar-logo w-32 h-28 sm:w-28 sm:h-28 md:w-32 md:h-28"
              />
              <!-- Subtle glow effect -->
              <div class="absolute inset-0 bg-gradient-to-br from-brown-400/20 to-brown-600/20 rounded-full blur-xl opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            
            <!-- Brand Text -->
            <!-- <div class="hidden sm:block">
              <h1 class="text-lg md:text-xl lg:text-2xl font-bold bg-gradient-to-r from-brown-700 to-brown-900 bg-clip-text text-transparent">
                کبابی مارو
              </h1>
              <p class="text-xs md:text-sm text-brown-500 font-medium">منوی دیجیتال</p>
            </div> -->
          </div>

          <!-- Navigation Buttons -->
          <div class="flex items-center space-x-2 md:space-x-3 space-x-reverse">
            <!-- Contact Button -->
            <button 
              @click="scrollToContact"
              class="navbar-btn group relative bg-gradient-to-r from-brown-600 to-brown-700 text-white px-3 py-2 md:px-6 md:py-2.5 rounded-full text-xs md:text-sm font-medium hover:from-brown-700 hover:to-brown-800 transition-all duration-300 hover:scale-105 shadow-md hover:shadow-lg"
            >
              <span class="relative z-10 flex items-center space-x-1 md:space-x-2 space-x-reverse">
                <span class="text-xs md:text-sm">📞</span>
                <span class="hidden sm:inline">تماس</span>
              </span>
              <!-- Hover effect -->
              <div class="absolute inset-0 bg-gradient-to-r from-brown-500 to-brown-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- Hero Section -->
    <section class="relative py-12 bg-gradient-to-br from-beige-100 to-beige-200 overflow-hidden">
      <div class="container mx-auto px-2 text-center">
        <div class="max-w-2xl mx-auto animate-fade-in">
          <h2 class="text-3xl md:text-2xl font-bold text-brown-800 mb-4">
            منوی ویژه کبابی مارو
          </h2>
                     <p class="text-lg text-brown-600 mb-2 leading-relaxed">
             تجربه‌ای منحصر به فرد از کباب‌های خوشمزه و نوشیدنی‌های گرم در فضایی آرام و دلنشین
           </p>
          <!-- <div class="flex justify-center space-x-4 space-x-reverse">
            <div class="text-center">
              <div class="text-2xl font-bold text-brown-600">50+</div>
              <div class="text-sm text-brown-500">محصول متنوع</div>
            </div>
            <div class="w-px bg-brown-300"></div>
            <div class="text-center">
              <div class="text-2xl font-bold text-brown-600">4</div>
              <div class="text-sm text-brown-500">دسته‌بندی</div>
            </div>
          </div> -->
        </div>
      </div>
             <div class="absolute top-10 left-10 text-2xl text-brown-300 animate-float">🍖</div>
       <div class="absolute top-20 right-20 text-xl text-brown-300 animate-float" style="animation-delay: 1s;">🥙</div>
       <div class="absolute bottom-10 left-20 text-xl text-brown-300 animate-float" style="animation-delay: 2s;">☕</div>
    </section>

    <!-- Categories Section -->
    <section class="py-6 bg-white">
      <div class="container mx-auto px-4">
        <h3 class="text-2xl font-semibold text-brown-800 text-center mb-6 animate-slide-up">
          دسته‌بندی‌های منو
        </h3>
        <div class="relative">
          <div v-if="categories.length > 0" class="flex space-x-4 space-x-reverse overflow-x-auto scrollbar-hide pb-4">
            <div 
              v-for="(category, index) in categories" 
              :key="category.id"
              @click="selectCategory(category)"
              :class="[
                'category-card flex-shrink-0 cursor-pointer transition-all duration-300 hover:scale-105 animate-slide-in-right',
                selectedCategory?.id === category.id 
                  ? 'bg-brown-600 text-white shadow-lg' 
                  : 'bg-beige-100 text-brown-700 hover:bg-beige-200'
              ]"
              :style="{ animationDelay: index * 100 + 'ms' }"
            >
            <div class="w-28 h-28 bg-white/20 rounded-xl flex items-center justify-center mb-3 overflow-hidden">
              <img v-if="isImageUrl(category.icon)" :src="category.icon" class="max-w-full max-h-full object-contain" />
              <span v-else class="text-2xl">{{ category.icon }}</span>
            </div>
              <h4 :class="['font-medium text-sm', selectedCategory?.id === category.id ? 'text-brown-900' : 'text-brown-800']">
                {{ category.name }}
              </h4>
              <p :class="['text-xs', selectedCategory?.id === category.id ? 'text-brown-700' : 'text-brown-600/80']">
                {{ category.items.length }} محصول
              </p>
            </div>
          </div>
          <div v-else class="flex justify-center py-8">
            <div class="text-center">
              <div class="w-8 h-8 border-2 border-brown-300 border-t-brown-600 rounded-full animate-spin mx-auto mb-4"></div>
              <p class="text-brown-600">در حال بارگذاری دسته‌بندی‌ها...</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Menu Items Section -->
    <section class="py-8 bg-beige-50">
      <div class="container mx-auto px-4">
        <div v-if="selectedCategory" class="text-center mb-8 animate-fade-in">
          <h3 class="text-2xl font-semibold text-brown-800 mb-2">
            {{ selectedCategory.name }}
          </h3>
          <p class="text-brown-600">{{ selectedCategory.description }}</p>
        </div>
        <div v-if="isLoading" class="text-center py-12">
          <div class="w-12 h-12 border-4 border-brown-300 border-t-brown-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p class="text-brown-600">در حال بارگذاری محصولات...</p>
        </div>
        <div v-else-if="filteredItems.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div 
            v-for="(item, index) in filteredItems" 
            :key="item.id"
            @click="showItemDetails(item)"
            class="menu-item-card bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer hover:scale-105 border border-beige-200 animate-scale-in"
            :style="{ animationDelay: index * 100 + 'ms' }"
          >
                         <div class="w-full h-48 bg-gradient-to-br from-beige-200 to-beige-300 rounded-xl mb-4 flex items-center justify-center overflow-hidden">
               <img v-if="item.image" :src="item.image" class="w-full h-full object-cover" />
               <img v-else src="@/assets/DefaultItem.jpeg" alt="Default Item Image" class="w-full h-full object-cover" />
             </div>
            <div class="space-y-3">
              <div class="flex justify-between items-start">
                <h4 class="font-semibold text-brown-800 text-lg">{{ item.name }}</h4>
                <span class="bg-brown-100 text-brown-700 px-3 py-1 rounded-full text-sm font-medium">
                  {{ formatPrice(item.price) }}
                </span>
              </div>
              <p class="text-brown-600 text-sm leading-relaxed line-clamp-2">{{ item.description }}</p>
              <div class="flex flex-wrap gap-2">
                <span v-if="item.isPopular" class="bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs font-medium">محبوب</span>
                <span v-if="item.isNew" class="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-medium">جدید</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center py-12">
          <div class="text-6xl mb-4">🍽️</div>
          <h3 class="text-xl font-semibold text-brown-800 mb-2">محصولی یافت نشد</h3>
          <p class="text-brown-600">در حال حاضر محصولی در این دسته‌بندی موجود نیست.</p>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section id="contact" class="bg-gradient-to-r from-gray-50 to-gray-100 py-4 md:py-8">
      <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto">
          <div class="text-center mb-4 md:mb-6">
            <h3 class="text-lg md:text-2xl font-bold text-gray-800 mb-1 md:mb-2">تماس با ما</h3>
            <p class="text-gray-600 text-sm md:text-base">برای رزرو میز یا اطلاعات بیشتر با ما در تماس باشید</p>
          </div>
          
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
            <!-- Address -->
            <div class="bg-white rounded-lg md:rounded-xl p-3 md:p-6 shadow-sm border border-gray-200 text-center hover:shadow-md transition-shadow">
              <div class="w-8 h-8 md:w-12 md:h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <span class="text-blue-600 text-sm md:text-xl">📍</span>
              </div>
              <h4 class="font-semibold text-gray-800 mb-1 md:mb-2 text-xs md:text-base">آدرس</h4>
              <p class="text-gray-600 text-xs md:text-sm leading-relaxed">ساری، انتهای 15 خرداد، تقاطع پیروزی 16، کبابی مارو</p>
            </div>
            
            <!-- Phone -->
            <div class="bg-white rounded-lg md:rounded-xl p-3 md:p-6 shadow-sm border border-gray-200 text-center hover:shadow-md transition-shadow">
              <div class="w-8 h-8 md:w-12 md:h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <span class="text-green-600 text-sm md:text-xl">📞</span>
              </div>
              <h4 class="font-semibold text-gray-800 mb-1 md:mb-2 text-xs md:text-base">تلفن</h4>
              <p class="text-gray-600 text-xs md:text-sm">09116330167</p>
            </div>
            
            <!-- Hours -->
            <div class="bg-white rounded-lg md:rounded-xl p-3 md:p-6 shadow-sm border border-gray-200 text-center hover:shadow-md transition-shadow">
              <div class="w-8 h-8 md:w-12 md:h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <span class="text-orange-600 text-sm md:text-xl">🕒</span>
              </div>
              <h4 class="font-semibold text-gray-800 mb-1 md:mb-2 text-xs md:text-base">ساعات کاری</h4>
              <p class="text-gray-600 text-xs md:text-sm">شنبه تا جمعه<br>۱۱ صبح تا ۱۲ شب</p>
            </div>
            
            <!-- Instagram -->
            <div class="bg-white rounded-lg md:rounded-xl p-3 md:p-6 shadow-sm border border-gray-200 text-center hover:shadow-md transition-shadow">
              <div class="w-8 h-8 md:w-12 md:h-12 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <span class="text-pink-600 text-sm md:text-xl">📱</span>
              </div>
              <h4 class="font-semibold text-gray-800 mb-1 md:mb-2 text-xs md:text-base">اینستاگرام</h4>
              <p class="text-gray-600 text-xs md:text-sm">@marookebab_</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-gray-900 text-gray-300 py-6">
      <div class="container mx-auto px-4">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <!-- <div class="flex items-center space-x-3 space-x-reverse mb-4 md:mb-0">
            <div class="w-8 h-8 bg-gradient-to-br from-brown-400 to-brown-600 rounded-full flex items-center justify-center">
              <span class="text-white text-sm">☕</span>
            </div>
            <div>
              <h4 class="font-semibold text-white">کبابی مارو</h4>
              <p class="text-xs text-gray-400">منوی دیجیتال</p>
            </div>
          </div> -->
          
                     <div class="text-center md:text-right">
             <p class="text-sm">© ۱۴۰4 کبابی مارو - تمامی حقوق محفوظ است</p>
             <p class="text-xs text-gray-500 mt-1">طراحی شده با ❤️ برای تجربه‌ای بهتر</p>
             <p class="text-xs text-gray-500 mt-1">
               <a href="https://majaro.ir" target="_blank" rel="noopener noreferrer" class="hover:text-gray-300 transition-colors">
                 طراحی و توسعه توسط Majaro
               </a>
             </p>
           </div>
        </div>
      </div>
    </footer>

    <!-- Item Details Modal -->
    <div v-if="selectedItem" class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4" @click="closeItemDetails">
      <div @click.stop class="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto animate-scale-in">
                 <div class="w-full h-64 bg-gradient-to-br from-beige-200 to-beige-300 rounded-t-2xl flex items-center justify-center overflow-hidden">
           <img v-if="selectedItem?.image" :src="selectedItem.image" class="w-full h-full object-cover" />
           <img v-else-if="selectedItem?.photos && selectedItem.photos.length" :src="selectedItem.photos[0]" class="w-full h-full object-cover" />
           <img v-else src="@/assets/DefaultItem.jpeg" alt="Default Item Image" class="w-full h-full object-cover" />
         </div>
        <div class="p-6">
          <div class="flex justify-between items-start mb-4">
            <h3 class="text-2xl font-semibold text-brown-800">{{ selectedItem.name }}</h3>
            <span class="bg-brown-100 text-brown-700 px-4 py-2 rounded-full font-semibold">{{ formatPrice(selectedItem.price) }}</span>
          </div>
          <p class="text-brown-600 leading-relaxed mb-6">{{ selectedItem.description }}</p>
          <div class="flex flex-wrap gap-2 mb-6">
            <span v-if="selectedItem.isPopular" class="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm font-medium">محبوب</span>
            <span v-if="selectedItem.isNew" class="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">جدید</span>
          </div>
          <button @click="closeItemDetails" class="w-full bg-brown-600 text-white py-3 rounded-xl font-medium hover:bg-brown-700 transition-colors duration-300">بستن</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import Lenis from 'lenis'
import { categoriesAPI, menuItemsAPI } from '@/services/api'

export default {
  name: 'MenuView',
  setup() {
    // Smooth-scroll and data fetching only
    const selectedCategory = ref(null)
    const selectedItem = ref(null)
    const categories = ref([])
    const menuItems = ref([])
    const error = ref(null)
    const isLoading = ref(true)

    const fetchCategories = async () => {
      try {
        console.log('[MenuView] Fetching categories...')
        const response = await categoriesAPI.getAll()
        console.log('[MenuView] Categories response:', response.data)
        categories.value = response.data.map(category => ({
          ...category,
          // Preserve server icon (URL or emoji). Fallback to emoji only if empty.
          icon: category.icon && category.icon.trim() ? category.icon : getCategoryIcon(category.name),
          items: [],
        }))
        console.log('[MenuView] Categories processed:', categories.value)
      } catch (err) {
        console.error('Error fetching categories:', err)
        error.value = 'خطا در بارگذاری دسته‌بندی‌ها'
        throw err
      }
    }

    const fetchMenuItems = async () => {
      try {
        console.log('[MenuView] Fetching menu items...')
        const response = await menuItemsAPI.getAll()
        console.log('[MenuView] Menu items response:', response.data)
        menuItems.value = response.data.map(item => ({
          ...item,
          icon: getItemIcon(item.name),
          isPopular: item.isPopular || false,
          isNew: item.isNew || false,
        }))
        console.log('[MenuView] Menu items processed:', menuItems.value)
        
        // Ensure categories are loaded before assigning items
        if (categories.value.length > 0) {
          categories.value.forEach(category => {
            category.items = menuItems.value.filter(item => item.categoryId === category.id)
          })
          console.log('[MenuView] Categories with items:', categories.value)
        } else {
          console.warn('[MenuView] No categories available when assigning items')
        }
      } catch (err) {
        console.error('Error fetching menu items:', err)
        error.value = 'خطا در بارگذاری محصولات'
        throw err
      } finally {
        isLoading.value = false
        console.log('[MenuView] Loading completed, isLoading:', isLoading.value)
      }
    }



    const getCategoryIcon = (categoryName) => {
      const iconMap = { 'قهوه': '☕', 'دمنوش': '🫖', 'صبحانه': '🥐', 'ناهار': '🥪', 'شام': '🍽️', 'دسر': '🍰', 'نوشیدنی': '🥤', 'ساندویچ': '🥪', 'سالاد': '🥗' }
      for (const [key, icon] of Object.entries(iconMap)) {
        if (categoryName.includes(key)) return icon
      }
      return '🍽️'
    }

    const getItemIcon = (itemName) => {
      const iconMap = { 'اسپرسو': '☕', 'کاپوچینو': '☕', 'لاته': '☕', 'چای': '🫖', 'پنکیک': '🥞', 'اوملت': '🍳', 'ساندویچ': '🥪', 'سالاد': '🥗', 'پاستا': '🍝', 'کیک': '🍰', 'دسر': '🍰', 'آیس': '🧊' }
      for (const [key, icon] of Object.entries(iconMap)) {
        if (itemName.includes(key)) return icon
      }
      return '🍽️'
    }

    const filteredItems = computed(() => {
      const items = !selectedCategory.value ? categories.value.flatMap(cat => cat.items) : selectedCategory.value.items
      console.log('[MenuView] filteredItems computed:', {
        selectedCategory: selectedCategory.value?.name,
        totalItems: items.length,
        items: items
      })
      return items
    })

    const selectCategory = (category) => {
      selectedCategory.value = selectedCategory.value?.id === category.id ? null : category
    }
    const showItemDetails = (item) => { selectedItem.value = item }
    const closeItemDetails = () => { selectedItem.value = null }
    const scrollToContact = () => { document.getElementById('contact').scrollIntoView({ behavior: 'smooth' }) }
    const formatPrice = (price) => new Intl.NumberFormat('fa-IR').format(price) + ' تومان'
    const isImageUrl = (val) => typeof val === 'string' && /^(https?:)?\//.test(val)

    const retryConnection = async () => {
      error.value = null
      isLoading.value = true
      try {
        // Load categories first, then menu items to ensure proper linking
        await fetchCategories()
        await fetchMenuItems()
        error.value = null
      } catch (err) {
        console.error('Retry failed:', err)
        error.value = 'خطا در اتصال به سرور'
      } finally {
        isLoading.value = false
      }
    }

    onMounted(async () => {
      const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
      })
      function raf(time) {
        lenis.raf(time)
        requestAnimationFrame(raf)
      }
      requestAnimationFrame(raf)

      isLoading.value = true
      try {
        // Load categories first, then menu items to ensure proper linking
        await fetchCategories()
        await fetchMenuItems()
      } catch (err) {
        console.error('Error during initial data loading:', err)
        isLoading.value = false
      }
    })

    return {
      categories,
      selectedCategory,
      selectedItem,
      filteredItems,
      error,
      isLoading,
      selectCategory,
      showItemDetails,
      closeItemDetails,
      scrollToContact,
      formatPrice,
      retryConnection,
      isImageUrl,
    }
  },
}
</script>

<style scoped>
.category-card { @apply w-32 h-32 flex flex-col items-center justify-center rounded-2xl; }
.menu-item-card { @apply relative overflow-hidden; }
.menu-item-card::before { content: ''; @apply absolute inset-0 bg-gradient-to-br from-brown-50 to-transparent opacity-0 transition-opacity duration-300; }
.menu-item-card:hover::before { @apply opacity-100; }
.line-clamp-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
.scrollbar-hide::-webkit-scrollbar { display: none; }
@keyframes float { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-10px); } }
.animate-float { animation: float 3s ease-in-out infinite; }

/* Mobile footer fixes */
@media (max-width: 767px) {
  footer {
    padding-bottom: env(safe-area-inset-bottom, 1rem);
    margin-bottom: 0;
  }
}
</style>


